// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Env from "../../core/Env.res.js";
import * as Form from "../../bundles/Form/Form.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Json from "../../primitives/Json.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as Title from "../../resources/typography/Title.res.js";
import * as React from "react";
import * as Future from "rescript-future/src/Future.res.js";
import * as Request from "../../core/Request.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as AuthLoginPage from "./AuthLoginPage.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stylex from "@stylexjs/stylex";
import * as JsxRuntime from "react/jsx-runtime";
function get(values, field) {
  if (field === "Password") {
    return values.password;
  } else {
    return values.confirm;
  }
}
function set(values, field, value) {
  if (field === "Password") {
    return {
      password: value,
      confirm: values.confirm
    };
  } else {
    return {
      password: values.password,
      confirm: value
    };
  }
}
let LoginResetFormLenses_ = {
  get: get,
  set: set
};
let LoginResetFormLenses = {
  get: get,
  set: set
};
let LoginResetForm = Form.Make(LoginResetFormLenses);
let styles = {
  container: {
    "alignItems-kGNEyG": "alignItems-x6s0dn4",
    "display-k1xSpc": "display-x78zum5",
    "flex-kUk6DE": "flex-x98rzlu",
    "flexDirection-kXwgrk": "flexDirection-xdt5ytf",
    "justifyContent-kjj79g": "justifyContent-xl56j7k",
    "marginTop-keoZOQ": "marginTop-xugmn4g",
    "width-kzqmXN": "width-x2cbyk5",
    $$css: "wino-gc:src/app/Auth/AuthLoginResetPage.res.js:54"
  },
  title: {
    "alignItems-kGNEyG": "alignItems-x6s0dn4",
    "display-k1xSpc": "display-x78zum5",
    "flexDirection-kXwgrk": "flexDirection-xdt5ytf",
    "paddingBlock-k8WAf4": "paddingBlock-xqp6ajr",
    "width-kzqmXN": "width-xh8yej3",
    $$css: "wino-gc:src/app/Auth/AuthLoginResetPage.res.js:63"
  }
};
let endpoint = Env.gatewayUrl() + "/auth/password-reset";
function encodeBody(tokenId, token, userId, newPassword) {
  return Json.encodeDict(Object.fromEntries([["tokenId", Json.encodeString(tokenId)], ["token", Json.encodeString(token)], ["userId", Json.encodeString(userId)], ["newPassword", Json.encodeString(newPassword)]]));
}
function decodeInvalidRequestFailure(error) {
  switch (error.kind) {
    case "ExpiredOneTimeToken":
      return "ExpiredOneTimeToken";
    case "NotFoundPasswordResetOneTimeToken":
      return "NotFoundPasswordResetOneTimeToken";
    default:
      return "UnknownServerFailure";
  }
}
function make(tokenId, token, userId, newPassword) {
  return Future.mapError(Request.make(endpoint, "POST", {
    TAG: "JsonBody",
    _0: encodeBody(tokenId, token, userId, newPassword)
  }, false, undefined), undefined, error => {
    if (typeof error !== "object" || error.TAG !== "InvalidRequestFailures") {
      return;
    } else {
      return Stdlib_Option.map(error._0[0], decodeInvalidRequestFailure);
    }
  });
}
let ResetPasswordRequest = {
  endpoint: endpoint,
  encodeBody: encodeBody,
  decodeInvalidRequestFailure: decodeInvalidRequestFailure,
  make: make
};
let schema = [{
  TAG: "Password",
  _0: "Password"
}, {
  TAG: "CustomString",
  _0: "Confirm",
  _1: (value, values) => {
    if (values.password === value) {
      return {
        TAG: "Ok",
        _0: undefined
      };
    } else {
      return {
        TAG: "Error",
        _0: I18n.t("Password and its confirmation must be identical")
      };
    }
  }
}];
function AuthLoginResetPage(props) {
  let resetPasswordRequest = props.resetPasswordRequest;
  let successRoute = props.successRoute;
  let token = props.token;
  let tokenId = props.tokenId;
  let userId = props.userId;
  let match = React.useState(() => {});
  let setNotfication = match[1];
  let notification = match[0];
  let navigate = Navigation.useNavigate();
  let onSubmitSuccess = res => {
    if (res !== undefined) {
      if (res === I18n.t("Your password has been correctly modified")) {
        return navigate(undefined, successRoute);
      } else {
        return setNotfication(param => ({
          TAG: "Danger",
          _0: res
        }));
      }
    }
  };
  let onSubmitFailure = error => setNotfication(param => ({
    TAG: "Danger",
    _0: error
  }));
  let formPropState = LoginResetForm.useFormPropState({
    initialValues: {
      password: "",
      confirm: ""
    },
    schema: schema,
    onSubmitFailure: onSubmitFailure,
    onSubmitSuccess: onSubmitSuccess
  });
  let onSubmit = (param, param$1) => Future.mapError(Future.mapOk(resetPasswordRequest(tokenId, token, userId, param$1.password), undefined, param => I18n.t("Your password has been correctly modified")), undefined, error => {
    if (error === undefined) {
      return I18n.t("An unexpected error occured. Please try again or contact the support.");
    }
    switch (error) {
      case "ExpiredOneTimeToken":
      case "NotFoundPasswordResetOneTimeToken":
        return I18n.t("The link has expired");
      case "UnknownServerFailure":
        return I18n.t("An unexpected error occured. Please try again or contact the support.");
    }
  });
  let onRequestCloseNotificationBanner = () => setNotfication(param => {});
  let newrecord = {
    ...{
      className: "alignItems-x6s0dn4 display-x78zum5 flex-x98rzlu flexDirection-xdt5ytf justifyContent-xl56j7k marginTop-xugmn4g width-x2cbyk5",
      "data-style-src": "wino-gc:src/app/Auth/AuthLoginResetPage.res.js:54"
    }
  };
  let newrecord$1 = {
    ...{
      className: "alignItems-x6s0dn4 display-x78zum5 flexDirection-xdt5ytf paddingBlock-xqp6ajr width-xh8yej3",
      "data-style-src": "wino-gc:src/app/Auth/AuthLoginResetPage.res.js:63"
    }
  };
  newrecord.children = [JsxRuntime.jsx("div", (newrecord$1.children = JsxRuntime.jsx(Title.make, {
    children: I18n.t("Password resetting"),
    level: 1
  }), newrecord$1)), notification !== undefined ? JsxRuntime.jsx(AuthLoginPage.NotificationBanner.make, {
    notification: notification,
    onRequestClose: onRequestCloseNotificationBanner
  }) : null, JsxRuntime.jsxs(LoginResetForm.Core.Provider.make, {
    children: [JsxRuntime.jsx(LoginResetForm.ControlEnterKey.make, {
      onSubmit: onSubmit
    }), JsxRuntime.jsxs(Stack.make, {
      children: [JsxRuntime.jsx(LoginResetForm.InputPassword.make, {
        field: "Password",
        label: I18n.t("New password"),
        placeholder: I18n.t("New password"),
        hideError: true,
        hideRequired: true,
        showTypingValidation: true
      }), JsxRuntime.jsx(LoginResetForm.InputPassword.make, {
        field: "Confirm",
        label: I18n.t("New password confirmation"),
        placeholder: I18n.t("New password confirmation"),
        hideRequired: true
      }), JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsx(LoginResetForm.SubmitButton.make, {
          label: I18n.t("Reset password"),
          onSubmit: onSubmit
        }),
        spaceY: "xsmall"
      })],
      space: "large"
    })],
    propState: formPropState
  })];
  return JsxRuntime.jsxs("div", newrecord);
}
let resetPasswordRequest = make;
let make$1 = AuthLoginResetPage;
export { LoginResetFormLenses_, LoginResetFormLenses, LoginResetForm, styles, ResetPasswordRequest, resetPasswordRequest, schema, make$1 as make };
/* LoginResetForm Not a pure module */